/**
 * buyback-url.js — single source of truth for buyback URL format.
 *
 * Producers: quote-widget.js, brand-models.liquid, sell-categories.liquid,
 *            popular-models.liquid CTAs.
 * Consumer:  brand-models.liquid (TKQuote.urlFor), sell-categories.liquid (TKQuote.build).
 *
 * Contract — change the format here, all callers follow:
 *   PAGE  = "/pages/trade-in"
 *   KEYS  = ["type", "brand", "model"]   (ordered; future keys appended only)
 *
 * Stability: TKQuote object is frozen. Bump VERSION on breaking change.
 */
(function () {
  "use strict";

  var VERSION = 1;
  var PAGE = "/pages/trade-in";
  var KEYS = Object.freeze(["type", "brand", "model"]);

  var LEGACY_BRAND_PREFIX = /^(apple|samsung|google|oneplus|xiaomi)-/;

  function asStr(v) { return v == null ? "" : String(v).trim(); }

  function normalizeModelSlug(slug) {
    var s = asStr(slug).toLowerCase();
    if (!s) return "";
    return s.replace(LEGACY_BRAND_PREFIX, "");
  }

  function build(params) {
    var p = params || {};
    var qs = [];
    var hasModel = false;
    for (var i = 0; i < KEYS.length; i++) {
      var k = KEYS[i];
      var v = asStr(p[k]);
      if (k === "model") { v = normalizeModelSlug(v); if (v) hasModel = true; }
      if (v) qs.push(encodeURIComponent(k) + "=" + encodeURIComponent(v));
    }
    var hash = hasModel ? "#step=4" : (asStr(p.brand) ? "#step=3" : (asStr(p.type) ? "#step=2" : ""));
    return PAGE + (qs.length ? "?" + qs.join("&") : "") + hash;
  }

  function parse(input) {
    var sp;
    if (input instanceof URLSearchParams) sp = input;
    else if (typeof input === "string") sp = new URLSearchParams(input.charAt(0) === "?" ? input.slice(1) : input);
    else sp = new URLSearchParams(typeof location !== "undefined" ? location.search : "");
    var out = {};
    for (var i = 0; i < KEYS.length; i++) {
      var k = KEYS[i];
      var v = sp.get(k);
      if (v) out[k] = k === "model" ? normalizeModelSlug(v) : v;
    }
    return out;
  }

  function typeFromCategory(cat) {
    if (!cat || typeof window === "undefined" || !window.TK_TYPE_CATEGORY) return null;
    var map = window.TK_TYPE_CATEGORY;
    for (var k in map) if (Object.prototype.hasOwnProperty.call(map, k) && map[k] === cat) return k;
    return null;
  }

  /**
   * Derive {type, brand, model} from a catalog device record.
   * Supports both new shape (category_slug, brand_slug, slug)
   * and legacy shape (type, brand, slug).
   */
  function fromDevice(d) {
    if (!d) return {};
    return {
      type: typeFromCategory(d.category_slug) || d.type || null,
      brand: d.brand_slug || d.brand || null,
      model: d.slug || null
    };
  }

  function urlFor(d) { return build(fromDevice(d)); }

  window.TKQuote = Object.freeze({
    VERSION: VERSION,
    PAGE: PAGE,
    KEYS: KEYS,
    build: build,
    parse: parse,
    fromDevice: fromDevice,
    urlFor: urlFor,
    normalizeModelSlug: normalizeModelSlug
  });
})();
